import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=2407c1ce&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
import style0 from "./Settings.vue?vue&type=style&index=0&id=2407c1ce&prod&lang=css"
import style1 from "./Settings.vue?vue&type=style&index=1&id=2407c1ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2407c1ce",
  null
  
)

export default component.exports